import { BankNames } from '@/constants';
import type { OfferResponseFromApi } from '@/types/offers';

import type { IBaseBankOffer } from '../../../types/base-offer.types';
import type { TEurasV2BankOffer } from '../../../types/euras-v2.types';

export const mapEuBankV2OfferFromApi = (
  baseBankOffer: IBaseBankOffer,
  response: OfferResponseFromApi
): TEurasV2BankOffer => {
  return {
    ...baseBankOffer,
    bankName: BankNames.euBankV2,
    productInfo: response?.request?.RequestsProducts
      ? response?.request?.RequestsProducts.find(
          (product) => product.product.bank_uuid === response.bank_uuid
        )
      : ''
  };
};
